export const logoUrl =
  "https://storage-hokkien.s3.ap-southeast-1.amazonaws.com/default/logo.svg";
